import * as z from 'zod';

import { WorkoutPlanId } from '../../../BrandedIds';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const FlexModCancellationReason = z.enum([
  'incompleteOrLatePayment',
  'missedPayment',
  'latePayment',
  'insufficientPayment',
  'ineligible',
]);
export type FlexModCancellationReason = z.infer<typeof FlexModCancellationReason>;

export const FlexModCancellationEvent = BaseLoanEvent.extend({
  type: z.literal('flexModCancellation'),
  workoutPlanId: WorkoutPlanId,
  reason: FlexModCancellationReason,
});
export type FlexModCancellationEvent = z.infer<typeof FlexModCancellationEvent>;
